"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_actions_button_html_1 = __importDefault(require("./widget-actions-button.html"));
require("./widget-actions-button.less");
(function (module) {
    'use strict';
    function WidgetActionsButtonController($filter, $q, downloadHelper, widgetManager, eventService, hotkey, env, widgetService, $injector, rsState, triggerOverrides, OVERRIDE_EVENTS, activeReport, metricsService) {
        var $ctrl = this, translate = $filter('translate');
        var TITLE_DISABLED_WIDGETS = [
            'pr.spacer',
            'pr.divider',
            'pr.image'
        ];
        var DOCX_EXPORT_ENABLED = new Set([
            'eng.pie',
            'eng.bar',
            'eng.line',
            'eng.table',
            'eng.stats'
        ]);
        var EXPORTS_DISABLED = [
            'pr.spacer',
            'pr.divider'
        ];
        var configFlags = triggerOverrides({
            event: OVERRIDE_EVENTS.CONFIG_FLAGS,
            sync: true,
            data: {}
        });
        angular.extend($ctrl, {
            getActionItems: function () {
                return getInsertTitleOrEditText().then(function (textItem) {
                    var ret = [
                        {
                            label: hotkey.buildHotkeyLabel('COPY', ['icon-commandkey', 'C']),
                            action: copyWidget
                        },
                        { divider: true }
                    ];
                    if (!configFlags.disableWidgetExports && !_.contains(EXPORTS_DISABLED, $ctrl.widget._type)) {
                        ret = ret.concat({ header: translate('EXPORT_AS') }, {
                            label: translate('PR.JPG'),
                            action: exportToJPG
                        }, {
                            label: translate('PR.DOCX'),
                            action: exportToDocx,
                            disabled: !isDocxWidgetExportSupported($ctrl.widget._type)
                        }, { divider: true });
                    }
                    ret.push({
                        label: translate('REMOVE'),
                        action: removeWidget
                    });
                    if (textItem) {
                        ret.splice(1, 0, textItem);
                    }
                    return ret;
                });
            }
        });
        function getInsertTitleOrEditText() {
            var type = $ctrl.widget._type;
            // Text widget gets an edit button
            if (type === 'pr.text') {
                return $q.when({
                    label: translate('EDIT'),
                    action: editText
                });
            }
            else if (!_.contains(TITLE_DISABLED_WIDGETS, type)) {
                var pageId = activeReport.getPageIdOfWidget($ctrl.widget);
                return rsState.getConfig($ctrl.widget._id, pageId, env.get('containerId')).then(function (config) {
                    // TODO: special case of text widget (edit) & non inlineTitle widgets (table)
                    if (config.productConfig && config.productConfig.widgetTitle) {
                        return {
                            label: translate('REMOVE_TITLE'),
                            action: removeTitle
                        };
                    }
                    else {
                        return {
                            label: translate('INSERT_TITLE'),
                            action: insertTitle
                        };
                    }
                });
            }
            return $q.when(null);
        }
        function exportToJPG() {
            metricsService.exportComplete('jpg');
            downloadHelper.downloadWidgetImage($ctrl.widget._id, $ctrl.widget._type);
        }
        function isDocxWidgetExportSupported(widgetType) {
            return DOCX_EXPORT_ENABLED.has(widgetType);
        }
        function exportToDocx() {
            var exportOptions = {
                type: 'docx',
                widgetId: $ctrl.widget._id,
                widgetType: $ctrl.widget._type,
                isWidgetExport: true
            };
            metricsService.exportComplete(exportOptions.type);
            // add data config information if configurable docx widget is supported
            if (isDocxWidgetExportSupported($ctrl.widget._type)) {
                var component_1 = widgetManager.getWidgetComponent($ctrl.widget._id);
                component_1.lifecycle.getDataConfig().then(function (dataConfig) {
                    var viewConfig = component_1.lifecycle.viewConfig;
                    exportOptions = _.assign(exportOptions, {
                        dataConfig: dataConfig,
                        viewConfig: viewConfig,
                        language: env.get('user').language,
                        widgetSettings: component_1.lifecycle.widgetSettings
                    });
                    // THIS IS KIND OF A HACK
                    var colorPaletteService = $injector.get('widget.componentBase.colorPaletteService');
                    viewConfig.colorPalette = colorPaletteService.getColorPalette(viewConfig.colorPaletteMeta);
                    downloadHelper.downloadWidgetDocx(exportOptions);
                });
            }
            else {
                downloadHelper.downloadWidgetDocx(exportOptions);
            }
        }
        function editText() {
            eventService.trigger('editText-' + $ctrl.widget._id + '-' + $ctrl.widget.layout.chunkIndex);
        }
        function removeTitle() {
            eventService.stream($ctrl.widget._id).trigger('removeTitle');
        }
        function insertTitle() {
            widgetManager.notifyWidget($ctrl.widget._id, 'widgetTitleRequest');
        }
        function removeWidget() {
            widgetService.deleteWidgets($ctrl.widget._id);
        }
        function copyWidget() {
            eventService.trigger('copyWidget');
        }
    }
    WidgetActionsButtonController.$inject = [
        '$filter',
        '$q',
        'prDownloadHelper',
        'pr.widgetManager',
        'prEventService',
        'pr.hotkeyUtil',
        'rsEnvironment',
        'pr.widgetOperationsService',
        '$injector',
        'rsState',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'prActiveReport',
        'prMetricsService'
    ];
    module.component('prWidgetActionsButton', {
        templateUrl: widget_actions_button_html_1.default,
        controller: WidgetActionsButtonController,
        bindings: {
            widget: '<'
        }
    });
})(angular.module('qualtrics.pr'));
